import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentBookingInformationQuery } from "@/features/experience-curation/queries/useBookingInformationQuery";
import { areNonCommercialFieldsEditableForUser } from "@/features/experience-curation/lib/viewTypeUtils";
import { useHasFunctionalNestedFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";

export const useCurationVoucherType = defineStore("curation-customer-info-voucher-type-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const bookingInfoQuery = useCurrentBookingInformationQuery();

  const initialValue = computed(() => bookingInfoQuery.data.value?.bookingInformation?.voucher_type ?? "");
  const { model, hasChanges, isFilled, reset } = usePrimitiveModelWithChanges(initialValue);

  const isRequired = true;
  const isReadonly = computed(() => curationExperienceStore.isReadonly || !areNonCommercialFieldsEditableForUser());
  const isVisible = computed(() => !curationExperienceStore.isCommercialView);
  const hasUnpublishedChange = useHasFunctionalNestedFieldChange((f) => f?.booking_information?.voucher_type);

  return {
    id: "voucher_type",
    model,
    isRequired,
    isReadonly,
    isVisible,
    hasChanges,
    hasUnpublishedChange,
    isFilled,
    reset,
  };
});
